// src/pages/Store.js
import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import '../styles/BellaBizarreStyle.css';

const Store = () => {
    const [embeds, setEmbeds] = useState([]);

    useEffect(() => {
        const fetchEmbeds = async () => {
            const snap = await getDocs(collection(db, 'storeEmbeds'));
            setEmbeds(snap.docs.map(d => d.data()));
        };
        fetchEmbeds();
    }, []);

    return (
        <div className="store-outer-container">
            <h1>Official Store</h1>
            {embeds.map((e, i) => (
                <div className="store-item" key={i} style={{ margin: '2rem 0' }}>
                    <h3>{e.title}</h3>
                    {e.imageUrl && (
                        <img src={e.imageUrl} alt={e.title} style={{ maxWidth: '300px', borderRadius: '8px' }} />
                    )}
                    <p>{e.description}</p>
                    <div dangerouslySetInnerHTML={{ __html: e.embedHtml }} />
                </div>
            ))}
        </div>
    );
};

export default Store;
